<template>
  <az-search
    :id="searchId"
    :filter="filtrosAtivos"
    @advanced-search="onAdvancedSearch"
    @simple-search="onSimpleSearch"
    @clear="onClear"
    :simple-search-placeholder="placeholder"
  >
    <template #search-items>
      <az-search-item>
        <v-text-field v-model="localFiltros.empresa" label="Empresa" placeholder="Nome ou razão social"/>
      </az-search-item>

      <az-search-item>
        <v-text-field v-model="localFiltros.assunto" :label="assuntoLabel" :placeholder="assuntoLabel"/>
      </az-search-item>

      <az-search-item>
        <v-text-field v-model="localFiltros.processo" label="Processo" placeholder="Número do processo"/>
      </az-search-item>

      <az-search-item>
        <v-text-field v-model="localFiltros.edital" label="Edital" placeholder="Número do edital"/>
      </az-search-item>

      <az-search-item>
        <v-text-field v-model="localFiltros.orgao" label="Órgão" placeholder="Nome ou sigla do órgão"/>
      </az-search-item>

      <az-search-item>
        <v-text-field v-model="localFiltros.objeto" label="Objeto" placeholder="Objeto da licitação"/>
      </az-search-item>

      <az-search-item>
        <az-combo-enum v-model="localFiltros.situacao" :enum-object="situacoes" label="Situação"/>
      </az-search-item>
    </template>
  </az-search>
</template>

<script>
export default {
  name: 'EsclarecimentoImpugnacaoFiltro',
  props: {
    filtros: { type: Object, default: () => ({}) },
    situacoes: { type: Object, default: () => ({}) },
    searchId: { type: String, default: 'esclarecimento-convidado-search' },
    placeholder: { type: String, default: "Filtrar processo" },
    assuntoLabel: { type: String, default: 'Assunto' }
  },
  data() {
    return {
      localFiltros: Object.assign({}, this.filtros)
    }
  },
  computed: {
    filtrosAtivos() {
      const ativos = {}
      Object.keys(this.localFiltros || {}).forEach(k => {
        const v = this.localFiltros[k]
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          ativos[k] = { value: v, valueTruncated: v }
        }
      })
      return ativos
    }
  },
  watch: {
    filtros: {
      handler(n) { this.localFiltros = Object.assign({}, n) },
      deep: true
    }
  },
  methods: {
    onSimpleSearch(value) {
      const val = (value !== undefined && value !== null) ? String(value).trim() : String(this.localFiltros.processo || '').trim()
      this.localFiltros.processo = val
       this.$emit('update:filtros', Object.assign({}, this.localFiltros))
       this.$emit('simple-search', val)
    },
    onAdvancedSearch() {
      this.$emit('update:filtros', Object.assign({}, this.localFiltros))
      this.$emit('advanced-search')
    },
    onClear() {
      this.localFiltros = { empresa: '', assunto: '', processo: '', edital: '', orgao: '', objeto: '', situacao: '' }
      this.$emit('update:filtros', Object.assign({}, this.localFiltros))
      this.$emit('clear')
    }
  }
}
</script>
